// This import loads the firebase namespace along with all its type information.
import Subtitles from './subtitles-model'

export async function load_subtitless(): Promise<Subtitles[]> {
  throw 'Not implemented'
}

export async function delete_subtitles(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_subtitles(): Promise<Subtitles> {
  throw 'Not implemented'
}
